import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface VibrationTooltipProps {
	toolIcon: JSX.Element;
	categoryName: string;
	content: string;
}

export function VibrationTooltip({ toolIcon, categoryName, content }: Readonly<VibrationTooltipProps>): JSX.Element {
	return (
		<S.CustomContainerTooltip>
			{toolIcon}
			<S.ContentTool isJDS_D86={false}>
				<h4>{I18n.get(categoryName)}</h4>
				<p>{content}</p>
			</S.ContentTool>
		</S.CustomContainerTooltip>
	);
}
